import { API_PROD_URL } from "src/utils/axios";

const NEW_BACKEND_URL = API_PROD_URL;
export { NEW_BACKEND_URL };
